import { combineReducers } from 'redux';
import errorsReducer from './errorsReducer';
// import orm from '../models/orm';
import session from './session';

const appReducer = combineReducers({
  errorsReducer,
  session,
  // entities: entities(orm),
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
